import { clone } from '../../utils/objects';
import type { Form, ContainerElement, FormElement, FormFillContext } from 'vince-core/pages/form-builder/types';

export const useFormEditStore = defineStore('formEditStore', () => {
    const rootContainer = ref<ContainerElement>();
    const editedElement = ref<FormElement>();
    const form = ref<Form>();
    const hoveredElementId = ref<string>();

    const formData = computed(() => {
        return form.value?.data;
    });

    function reindex (c: ContainerElement) {
        c.children.forEach((child: FormElement, index: number) => {
            child.position = index;
        });
    }

    function addElement (c: ContainerElement, pos: number, el: FormElement) {
        c.children.splice(pos, 0, el);
        reindex(c);
    }

    function initialize (rc: Form) {
        form.value = rc;
        editedElement.value = undefined;
    }

    function startElementEdit (e: FormElement | undefined) {
        editedElement.value = e ? clone(e) : undefined;
    }

    function findElement (id: string, containerElement: ContainerElement): [ContainerElement, FormElement] | undefined {
        for (const e of containerElement.children) {
            if (e.id === id) {
                return [containerElement, e];
            }
            if (Reflect.has(e, 'children')) {
                const res = findElement(id, e as ContainerElement);
                if (res) {
                    return res;
                }
            }
        }

        return undefined;
    }

    function applyElementEdit (e: FormElement) {
        const editedConfig = clone(e);
        const [container] = findElement(editedConfig.id, form.value!.container)!;
        container.children.splice(container.children.findIndex(it => it.id === e.id), 1, editedConfig);
    }

    function deleteElement (id: string) {
        const [container] = findElement(id, form.value!.container)!;
        container.children.splice(container.children.findIndex(it => it.id === id), 1);
    }

    function setHoveredElementId (id: string) {
        hoveredElementId.value = id;
    }

    const contextFields = computed(() => {
        return [
            'nickname',
            'lastName',
            'firstName',
            'tags',
            'email',
            'groups'] as (keyof FormFillContext)[];
    });

    const dataFields = computed(() => {
        return form.value?.data.fields.map((f) => {
            return { value: f.id, label: f.sourceFieldLabel };
        });
    });
    return {
        contextFields,
        dataFields,
        initialize,
        rootContainer,
        addElement,
        startElementEdit,
        editedElement,
        applyElementEdit,
        deleteElement,
        formData,
        form,
        setHoveredElementId,
        hoveredElementId
    };
});
